export const SILVERTIGER_THEME_APPEARANCE = 'SILVERTIGER_THEME_APPEARANCE';

export const LOBE_THEME_PRIMARY_COLOR = 'LOBE_THEME_PRIMARY_COLOR';

export const LOBE_THEME_NEUTRAL_COLOR = 'LOBE_THEME_NEUTRAL_COLOR';
